<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
  >
    <md-dialog-title>More AuthTX Details</md-dialog-title>
    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <form>
        <div v-for="[key, value] in Object.entries(data)" v-bind:key="key">
          <!--suppress JSIncompatibleTypesComparison -->
          <md-field v-if="value !== '' && value != null" class="md-layout-item md-small-size-100 md-size-100">
            <label>{{ toTitleCase(key) }}</label>
            <md-input type="text" :value="value" disabled v-if="typeof value !== 'object'"></md-input>
            <md-input type="text" :value="objectStringify(value)" disabled v-else></md-input>
          </md-field>
        </div>
      </form>

      <div class="md-layout-item md-size-100 text-right">
        <md-button @click="closeDialog">Close</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import _ from "lodash";

export default {
  name: "MoreInfo",
  props: {
    show: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const closeDialog = () => {
      emit("close");
    };

    const toTitleCase = (value) => {
      return _.startCase(_.toLower(value));
    };

    const objectStringify = (value) => {
      return JSON.stringify(value);
    };

    return {
      closeDialog,

      toTitleCase,
      objectStringify,
    };
  },
};
</script>
